import type { ReactNode } from 'react';
import { GripVertical } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function SortablePricingLine({
  code,
  description,
  enabled,
  excluded,
  children,
}: {
  code: string;
  description: string;
  enabled: boolean;
  excluded: boolean;
  children: ReactNode;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: code,
    disabled: !enabled,
  });
  return (
    <div
      ref={setNodeRef}
      className={'product-pricing-line' + (excluded ? ' is-excluded' : '')}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        position: 'relative',
        zIndex: isDragging ? 1 : undefined,
      }}
    >
      {children}
      {enabled ? (
        <button
          type="button"
          className="pricing-line-drag"
          aria-label={`${description} verslepen`}
          {...attributes}
          {...listeners}
        >
          <GripVertical size={14} />
        </button>
      ) : (
        <span />
      )}
    </div>
  );
}
